// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__12Imr","closeBtn":"styles_closeBtn__AuIB4","text":"styles_text__i5DXn"};